export default __webpack_public_path__ + "static/media/1_0150.4f5990aa.webp";